import React from "react";
import Slider from "react-slick";

const gallery = (props) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay:true,
    autoplayspeed:3000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="container-fluid gallerySlide">
      <div className="row">
        <h4 className="text-center galleryHeading"> Gallery</h4>
        <Slider {...sliderSettings}>
          {props.galleries.map((gallery) => {
            return (
              <div className="galleryImages" key={gallery.id}>
                <img
                  src={`${process.env.REACT_APP_IMAGE_STORAGE}${gallery.image}`}
                  alt=""
                  className="galleryImage"
                />
              </div>
            );
          })}
          {props.galleries.map((gallery) => {
            return (
              <div className="galleryImages" key={gallery.id}>
                <img
                  src={`${process.env.REACT_APP_IMAGE_STORAGE}${gallery.image}`}
                  alt=""
                  className="galleryImage"
                />
              </div>
            );
          })}
          {props.galleries.map((gallery) => {
            return (
              <div className="galleryImages" key={gallery.id}>
                <img
                  src={`${process.env.REACT_APP_IMAGE_STORAGE}${gallery.image}`}
                  alt=""
                  className="galleryImage"
                />
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default gallery;
